// extracted by mini-css-extract-plugin
module.exports = {"dark":"_17Zhw","light":"_1Z8go"};